/**
 * Public marketing navigation — single source of truth (PRD: ptexp/AI/exp-prd-deploy.md).
 *
 * Top nav:
 * - Products → Current Product (same-page anchor on `/` → #current-product), Upcoming
 * - About → FAQ, Use Cases, Blog
 *
 * Footer legal/company links live in contentSections.ts (footerNavigation).
 */
export const CURRENT_PRODUCT_ANCHOR = '/#current-product';

export type PublicNavItem = {
  label: string;
  /** Route path or hash path for home anchor */
  href: string;
  /** Use <a> for hash navigation to landing section (works from any origin path). */
  isExternalAnchor: boolean;
};

export const PUBLIC_NAV_PRODUCTS: PublicNavItem[] = [
  { label: 'Current Product', href: CURRENT_PRODUCT_ANCHOR, isExternalAnchor: true },
  { label: 'Upcoming', href: '/upcoming', isExternalAnchor: false },
];

export const PUBLIC_NAV_ABOUT: PublicNavItem[] = [
  { label: 'FAQ', href: '/faq', isExternalAnchor: false },
  { label: 'Use Cases', href: '/use-cases', isExternalAnchor: false },
  { label: 'Blog', href: '/blog', isExternalAnchor: false },
];

/** Flat mobile menu order (Products block then About block, same labels as desktop). */
export const PUBLIC_NAV_MOBILE_FLAT: PublicNavItem[] = [...PUBLIC_NAV_PRODUCTS, ...PUBLIC_NAV_ABOUT];
